import { JobStatus, PillKind, ShopifyStatus, ShopifyTabKey } from "../types/integrations";
import { PricingData } from "../types/pricingType";

export const whatsaapNumber = "+919113887558";
export const instaId = "https://www.instagram.com/empedance_official";
export const linkedInId =
  "https://www.linkedin.com/company/empedance-consultancy-services";

export const mailId = "help@empedance.com";
export const hrMailId = "hr@empedance.com";

//====================== Images ======================
export const mobileAndAndroid =
  "https://clapurban.blr1.digitaloceanspaces.com/1734159840440_mobile_app_development.svg";
export const websiteDevelopment =
  "https://clapurban.blr1.digitaloceanspaces.com/1734160798840_website_development.jpg";
export const uiUxDesign =
  "https://clapurban.blr1.digitaloceanspaces.com/1734160961875_ui_ux_design.jpg";
export const artificialInteligence =
  "https://clapurban.blr1.digitaloceanspaces.com/1734161133085_ai.jpg";

export const VideoEditing =
  "https://clapurban.blr1.digitaloceanspaces.com/1734161244228_video_editing.jpg";

export const ServiceLines =
  "https://clapurban.blr1.digitaloceanspaces.com/1734161403611_services_lines.svg";
export const whoAreWeBanner =
  "https://clapurban.blr1.digitaloceanspaces.com/1734166881804_about_emplux.jpg";

export const OfficeImage =
  "https://clapurban.blr1.digitaloceanspaces.com/1734167644166_empedance_office.jpg";
export const AboutUsLines =
  "https://clapurban.blr1.digitaloceanspaces.com/1734168291601_about_empedance_line.svg";
export const DefaultClient =
  "https://clapurban.blr1.digitaloceanspaces.com/1734181921061_default_client_image.png";

export const mobileServiceImages = [
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539798_mobile_app_development_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539700_website_development_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539749_ui_ux_design_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539838_digital_marketing.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539921_artificial_inteligence_sm.svg",
  "https://clapurban.blr1.digitaloceanspaces.com/1734209539877_video_editing_sm.svg",
];

export const altText = [
  "Professional web and mobile app development services tailored for businesses of all sizes.",
  "Custom website design and mobile app solutions to drive your digital growth.",
  "Expert web design and mobile app development for scalable digital solutions.",
  "Top web development and mobile app company delivering tailored digital experiences.",
  "Empowering businesses with custom website and mobile application development.",
  "Your trusted partner for innovative web design and mobile app solutions.",
  "Delivering high-performance websites and mobile apps for growing businesses.",
  "Customized web design, mobile app development, and digital marketing solutions.",
  "Leading digital agency specializing in web design, mobile development, and SEO services.",
  "Scalable, secure, and user-friendly web and mobile app development services.",
  "Transform your ideas into reality with our web and mobile app development expertise.",
  "Innovative web design and mobile app development solutions for every industry.",
  "Custom-built websites and mobile apps to meet unique business goals.",
  "Enhance your online presence with our professional web and app development services.",
  "Building engaging digital experiences with bespoke web and mobile applications.",
  "Your digital transformation partner for web design and mobile app innovation.",
  "Drive results with expert web design, mobile app development, and SEO strategies.",
  "Tailored web and mobile app solutions for businesses seeking digital excellence.",
  "Providing exceptional web and mobile development services to accelerate growth.",
  "Your go-to agency for creative web design, mobile apps, and digital marketing solutions.",
];


export const JSON_COLORS = {
  key: "text-violet-500",
  string: "text-emerald-600",
  number: "text-blue-600",
  boolean: "text-amber-700",
  null: "text-gray-400",
};

export interface ReviewItem {
    id: string;
    name: string;
    role: string;
    company: string;
    rating: number; // out of 5
    review: string;
}

export const reviews: ReviewItem[] = [
    {
        id: "1",
        name: "Aarav Mehta",
        role: "Head of ABC",
        company: "XYZ",
        rating: 5,
        review:
            "We cut customer-support reply time from 4 hours to 90 seconds. The bot training is genuinely magical.",
    },
    {
        id: "2",
        name: "Priya Sharma",
        role: "Founder",
        company: "ShopLane",
        rating: 5,
        review:
            "Bulk campaigns that used to take our team a full day now run in minutes, with better delivery rates.",
    },
    {
        id: "3",
        name: "Rohan Iyer",
        role: "Growth Lead",
        company: "Bloomstack",
        rating: 4,
        review:
            "The dashboard alone justified the switch. Real-time analytics finally make sense to our whole team.",
    },
];

export interface ServiceItem {
    id: string;
    icon: string;
    heading: string;
    description: string;
}

export const services: ServiceItem[] = [
    {
        id: "1",
        icon: "/images/bulk.svg",
        heading: "Bulk Messaging",
        description:
            "Send personalized WhatsApp messages to thousands of contacts instantly.",
    },
    {
        id: "2",
        icon: "/images/template.svg",
        heading: "Template Manager",
        description:
            "Create and manage pre-approved WhatsApp message templates with version control.",
    },
    {
        id: "3",
        icon: "/images/bot.svg",
        heading: "Bot Training",
        description:
            "Build intelligent auto-reply bots trained on your own data and FAQs.",
    },
    {
        id: "4",
        icon: "/images/analytics.svg",
        heading: "Message Analytics",
        description:
            "Track sent, delivered, and read rates with beautiful real-time charts.",
    },
    {
        id: "5",
        icon: "/images/contacts.svg",
        heading: "Contact Management",
        description:
            "Organize and segment your customer contact list with tags and lists.",
    },
    {
        id: "6",
        icon: "/images/restapi.svg",
        heading: "REST API Access",
        description:
            "Integrate WhatsApp messaging directly into your own applications.",
    }
];

export const steps = [
  {
    step: "STEP 1",
    title: "Connect WhatsApp",
    description:
      "Hook up your Business API in under 5 minutes with our guided onboarding.",
    icon: "/images/switch.svg",
  },
  {
    step: "STEP 2",
    title: "Build templates & audience",
    description:
      "Import contacts, segment by tags, and ship pre-approved message templates.",
    icon: "/images/users.svg",
  },
  {
    step: "STEP 3",
    title: "Send, automate & analyze",
    description:
      "Trigger campaigns, route replies to bots, and watch metrics in real time.",
    icon: "/images/current.svg",
  },
];

export const plans = [
    {
        id: "starter",
        title: "Free",
        price: { monthly: 0, annually: 0 },
        billingNote: "Free forever",
        description: "Perfect for individuals getting started.",
        buttonText: "Start Free",
        isPopular: false,
        isEnterprise: false,
        isActive: false,
        features: [
            "500 messages/month",
            "1 WhatsApp number",
            "Basic templates",
            "Community support",
        ],
    },
    {
        id: "pro",
        title: "Pro",
        price: { monthly: 2999, annually: 1999 },
        billingNote: "per month, billed annually",
        description: "For growing teams ready to scale.",
        buttonText: "Start Pro Trial",
        isPopular: true,
        isEnterprise: false,
        isActive: false,
        features: [
            "10,000 messages/month",
            "3 WhatsApp numbers",
            "Advanced templates",
            "Audience segmentation",
            "Analytics dashboard",
            "Priority support",
        ],
    },
    {
        id: "enterprise",
        title: "Enterprise",
        price: { monthly: 9999, annually: 7999 },
        billingNote: "per month, billed annually",
        description: "Custom automation at scale.",
        buttonText: "Talk to Sales",
        isPopular: false,
        isEnterprise: true,
        isActive: false,
        features: [
            "Unlimited messages",
            "Unlimited numbers",
            "Custom workflows",
            "Dedicated account manager",
            "SLA & uptime guarantee",
            "API access",
        ],
    },
];

export const bubbleVariants = {
  drift1: {
    x: [0, 6, -4, 0],
    y: [0, -10, -16, 0],
    scale: [1, 1.03, 0.98, 1],
  },
  drift2: {
    x: [0, -8, 5, 0],
    y: [0, -12, -6, 0],
    scale: [1, 1.02, 1.04, 1],
  },
  drift3: {
    x: [0, 4, -6, 0],
    y: [0, -8, -14, 0],
    scale: [1, 0.97, 1.03, 1],
  },
  drift4: {
    x: [0, -5, 7, 0],
    y: [0, -14, -8, 0],
    scale: [1, 1.04, 0.98, 1],
  },
  drift5: {
    x: [0, 8, -3, 0],
    y: [0, -6, -12, 0],
    scale: [1, 1.02, 1.05, 1],
  },
  drift6: {
    x: [0, -6, 4, 0],
    y: [0, -10, -18, 0],
    scale: [1, 0.98, 1.03, 1],
  },
};

// src/pages/admin/integrations/zoho/constants.js
export const ZOHO = {
  key: 'ZOHO',
  name: 'Zoho CRM',
  color: '#c8202f',
  blurb:
    'Welcome new leads and contacts on WhatsApp, and turn WhatsApp chats into Zoho leads.',
};

export const SHOPIFY = {
  key: 'SHOPIFY' as const,
  name: 'Shopify',
  color: '#5e8e3e',
  blurb:
    'Abandoned cart recovery, COD confirmation, order and shipping updates on WhatsApp.',
};

export const STATUS: Record<ShopifyStatus, { label: string; cls: PillKind }> = {
  CONNECTED: { label: 'Connected', cls: 'good' },
  PENDING: { label: 'Finish connecting', cls: 'warn' },
  ERROR: { label: 'Needs attention', cls: 'bad' },
  NOT_CONNECTED: { label: 'Not connected', cls: 'muted' },
};

export const JOB_STATUS: Record<JobStatus, PillKind> = {
  SCHEDULED: 'muted',
  SENDING: 'warn',
  SENT: 'good',
  SKIPPED: 'muted',
  FAILED: 'bad',
  CANCELLED: 'muted',
};

export const TABS: ReadonlyArray<readonly [ShopifyTabKey, string]> = [
  ['flows', 'Automations'],
  ['activity', 'Activity'],
  ['settings', 'Settings'],
  ['connect', 'Connection'],
] as const;

export const SETTING_FIELDS: ReadonlyArray<
  readonly [string, string, string?, boolean?]
> = [
  ['storeName', 'Store name', 'Used in messages as the store name'],
  ['storeUrl', 'Store address', 'https://…'],
  ['discountCode', 'Discount code', 'For the third cart reminder and re-order nudges'],
  ['reviewUrl', 'Review link', 'Where customers leave a review (https://…)'],
  ['fallbackImage', 'Fallback image', 'Header image when a product has none (https://…)'],
  ['codConfirmTag', 'Tag for confirmed COD orders'],
  ['codCancelTag', 'Tag for cancelled COD orders'],
  ['cancelOnCodReply', 'Cancel the order in Shopify when the customer replies Cancel', undefined, true],
  ['markPaidOnPayment', 'Mark COD orders paid when the Razorpay link is paid', undefined, true],
];
